import { Box, Text } from '@mantine/core'

import clsx from '@/utils/clsx'

import styles from './index.module.css'

interface TypeItemProps {
  isActive: boolean
  label: string
  onClick: () => void
}

export default function TypeItem({ isActive, label, onClick }: TypeItemProps) {
  return (
    <Box
      className={clsx({
        [styles.typeItem]: true,
        [styles.typeItemActive]: isActive,
      })}
      onClick={onClick}
    >
      <Text variant={'subtitle'}>{label}</Text>
    </Box>
  )
}
